module.exports = __webpack_public_path__ + "static/logo-hispanic-federation-d0b9cd2c19c704e467c49618657465d6.png";